import { Button } from "MVVM/Components/Button";
import { Box, Flex, Image } from "rebass/styled-components";
import styled from "styled-components";
import { Swiper } from "swiper/react";
import { Mousewheel, Pagination, Navigation } from "swiper/modules";
import Lottie from "lottie-react";

import { IContentItem } from "../../../Homepage/@types";
import { StyledSwiperSlide } from "MVVM/Views/Homepage/styledComponents";
import { ContentItem } from "MVVM/Views/Homepage/ContentItem";
import Loading from "../../../../../animations/loading.json";
import { WrappedWidgetViewModel } from "./ViewModel";
import { usePortal } from "MVVM/Hooks/usePortal";
import { Wrapped } from "../..";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;

const Wrapped2024Widget = ({ username }: { username: string | undefined }) => {
  const { data, error, loading } = WrappedWidgetViewModel();
  const {
    portalOpen: wrappedPortalOpen,
    setPortalOpen: setWrappedPortalOpen,
    Portal: WrappedPortal,
  } = usePortal(<Wrapped period="2024" username={username} />, "root");

  if (error) return <></>;

  const clips = data?.clipsReloaded?.nodes;

  if (!clips?.length) return <></>;

  return (
    <Container>
      {wrappedPortalOpen && WrappedPortal}
      <CampaignColumn>
        <Image
          width="300"
          flexShrink={0}
          src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/wrapup/2024/widget.png`}
          style={{ zIndex: 2 }}
        />
        {username && (
          <Button
            size="small"
            style={{ width: "240px" }}
            mt={4}
            onClick={() => setWrappedPortalOpen(true)}
          >
            View My Reloaded
          </Button>
        )}
      </CampaignColumn>
      <ClipsContainer>
        {loading ? (
          <Flex justifyContent="center" alignItems="center">
            <Lottie
              animationData={Loading}
              loop={true}
              style={{ height: "24px", width: "24px" }}
            />
          </Flex>
        ) : (
          <Box
            style={{
              position: "relative",
              width: "100%",
            }}
          >
            <Swiper
              centeredSlides={false}
              spaceBetween={16}
              slidesPerView={1}
              mousewheel={false}
              breakpoints={{
                1024: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 4,
                },
                2000: {
                  slidesPerView: 5,
                },
              }}
              modules={[Mousewheel, Pagination, Navigation]}
            >
              {clips.map((item: IContentItem, index: number) => (
                <StyledSwiperSlide key={index}>
                  <Box style={{ width: "100%" }}>
                    <ContentItem
                      item={item}
                      title=""
                      isMontage={false}
                      isWrapped={true}
                    />
                  </Box>
                </StyledSwiperSlide>
              ))}
            </Swiper>
          </Box>
        )}
      </ClipsContainer>
    </Container>
  );
};

const ClipsContainer = styled(Flex)`
  padding: 0 20px 0 0;
  width: 100%;

  @media (max-width: 900px) {
    display: none;
  }
`;

const Container = styled(Flex)`
  border-radius: 9px;
  gap: 60px;
  padding: 20px;
  position: relative;
  width: 100%;

  background: linear-gradient(0deg, #0c1318, #0c1318),
    linear-gradient(
      180deg,
      rgba(18, 120, 161, 0) 0%,
      rgba(18, 120, 161, 0.2) 100%
    );

  @media (max-width: 900px) {
    flex-direction: column;
  }

  @media (max-width: 600px) {
    &::before {
      background-position: top left; /* Shift the background image */
    }
  }
`;

const CampaignColumn = styled(Flex)`
  flex-direction: column;
  flex-shrink: 0;
  justify-content: space-evenly;

  @media (max-width: 900px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    justify-content: start;
    width: 100%;
  }

  @media (max-width: 600px) {
    align-items: center;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between;
    justify-content: start;
    width: 100%;
  }
`;

export { Wrapped2024Widget };
